@if (pageReady && accountDetail !== null) {
  <main class="gs-page bill-delivery-page">
    <div class="delivery-preference-container">
      <app-page-header [headerData]="pageHeader"></app-page-header>
      <div class="notification-container">
        <app-notification></app-notification>
      </div>
      <div class="gs-content-container">
        <div class="main-content-container">
          <div class="main-content">
            <div class="instructions-container">
              <h2>{{ pageLabels.instructionsHeader }}</h2>
              <p>{{ pageLabels.instructionsText }}</p>
            </div>
            <div class="delivery-options-container">
              @if (!hasEmail) {
                <p>{{ pageLabels.addEmailText }}</p>
                <app-email-form [emailData]="emailFormData"></app-email-form>
              }
              <form [formGroup]="prefForm">
                <mat-radio-group
                  [attr.aria-label]="pageLabels.optionsAriaLabel"
                  formControlName="preference"
                  class="delivery-option-checkbox"
                >
                  <mat-radio-button disableRipple="true" value="paperless">
                    <mat-card class="preference-option">
                      <mat-card-content>
                        <div>
                          <h3 class="preference-option-title">
                            {{ pageLabels.paperlessHeader }}
                            @if (isCurrentlyOnPaperless) {
                              <span class="enrolled-alert">{{ pageLabels.enrolledText }}</span>
                            }
                          </h3>
                          <p class="preference-option-text">{{ pageLabels.paperlessOptionDescription }}</p>
                        </div>
                      </mat-card-content>
                    </mat-card>
                  </mat-radio-button>
                  <mat-radio-button disableRipple="true" value="mail">
                    <mat-card class="preference-option">
                      <mat-card-content>
                        <div>
                          <h3 class="preference-option-title">
                            {{ pageLabels.mailHeader }}
                            @if (!isCurrentlyOnPaperless) {
                              <span class="enrolled-alert">{{ pageLabels.enrolledText }}</span>
                            }
                          </h3>
                          <p class="preference-option-text">{{ pageLabels.mailOptionDescription }}</p>
                        </div>
                      </mat-card-content>
                    </mat-card>
                  </mat-radio-button>
                </mat-radio-group>
                <mat-checkbox class="default-cb" formControlName="toc" color="primary" aria-labelledby="checkbox-error">
                  <div [innerHTML]="pageLabels.termsAndConditionsText"></div>
                </mat-checkbox>
                @if (showInlineError) {
                  <mat-error id="checkbox-error">{{ pageLabels.termsError }}</mat-error>
                }
              </form>
            </div>
            <div class="delivery-bottom-content">
              <div class="preferences-button-container">
                <button
                  class="gs-form-button-primary cancel-button"
                  mat-flat-button
                  color="primary"
                  (click)="clearChanges()"
                  [attr.aria-label]="pageLabels.cancelButtonAriaLabel"
                >
                  {{ pageLabels.cancelButtonText }}
                </button>
                <button
                  class="gs-form-button-primary"
                  mat-flat-button
                  color="primary"
                  (click)="changeDeliveryMethod()"
                  [attr.aria-label]="pageLabels.saveButtonAriaLabel"
                >
                  {{ pageLabels.saveButtonText }}
                </button>
              </div>
            </div>
          </div>
          <app-side-panel [panelData]="sidePanelData"></app-side-panel>
        </div>
        <div class="page-link-container">
          <mat-divider></mat-divider>
          <a
            [routerLink]="pageLabels.ctaLink.value.data.url"
            [attr.aria-label]="pageLabels.ctaLink.value.data.ariaLabel"
            >{{ pageLabels.ctaLink.value.data.linkText }}</a
          >
        </div>
      </div>
    </div>
  </main>
}
